
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"35","viewBox":"0 0 87 63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.391 0H80.87a5.394 5.394 0 015.39 5.394V56.61A5.393 5.393 0 0180.87 62H5.39A5.391 5.391 0 010 56.612V5.394A5.394 5.394 0 015.391 0z","fill":"#26A6D1"}}),_c('path',{attrs:{"d":"M13.91 21.565l-8.518 18.85h10.197l1.264-3.005h2.89l1.264 3.005h11.225v-2.294l1 2.294h5.806l1-2.342v2.342h23.345l2.838-2.927 2.658 2.927 11.99.025-8.545-9.397 8.545-9.478H69.065l-2.763 2.873-2.574-2.873H38.332l-2.18 4.865-2.232-4.865H23.743v2.216l-1.132-2.216H13.91zm1.973 2.677h4.97l5.65 12.782V24.242h5.446l4.364 9.165 4.022-9.165h5.418v13.526h-3.296l-.027-10.6-4.807 10.6h-2.949l-4.833-10.6v10.6h-6.782l-1.286-3.032h-6.947l-1.283 3.03H9.91l5.974-13.524zm32.887 0h13.405l4.1 4.428 4.232-4.428h4.1l-6.23 6.798 6.23 6.72h-4.286l-4.1-4.48-4.254 4.48H48.77V24.242zM18.3 26.53l-2.288 5.402h4.574l-2.286-5.402zm33.779.512v2.47h7.313v2.752H52.08v2.695h8.203l3.811-3.97-3.65-3.949H52.08v.002z","fill":"#fff"}})])
          )
        }
      }
    